import { render, staticRenderFns } from "./OrganizationDropdown.vue?vue&type=template&id=66e87dec"
import script from "./OrganizationDropdown.vue?vue&type=script&lang=ts"
export * from "./OrganizationDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports